import type { ConversationState } from "../lib/types";

const LABELS: Record<ConversationState, string> = {
  idle: "Not connected",
  listening: "Listening",
  thinking: "Thinking",
  searching: "Searching current information",
  speaking: "Speaking",
  error: "Something went wrong",
};

/**
 * Does more work than it looks like it does.
 *
 * "Searching" in particular is load-bearing: the pause while a search runs is
 * the same length either way, but shown like this it reads as diligence rather
 * than as the demo hanging.
 */
export function StatusPill({ state }: { state: ConversationState }) {
  return (
    <div className={`pill pill--${state}`} role="status" aria-live="polite">
      <span className="pill__dot" aria-hidden="true" />
      {LABELS[state]}
    </div>
  );
}
